const gradients = {
  gradient1: {
    fill: {
      startColor: 'rgba(162, 107, 250, 0.05)',
      endColor: 'rgba(203, 0, 221, 0.2)',
      scale: [1, 1],
    },
    stroke: {
      startColor: 'rgba(162, 107, 250, 1)',
      endColor: 'rgba(212, 135, 248, 1)',
    },
  },
  gradient2: {
    fill: {
      startColor: 'rgba(156, 91, 191, 0.15)',
      endColor: 'rgba(96, 94, 245, 0.55)',
      scale: [1, 1.7045],
    },
    stroke: {
      startColor: 'rgba(0, 96, 250, 1)',
      endColor: 'rgba(204, 116, 245, 1)',
    },
  },
  gradient3: {
    fill: {
      startColor: 'rgba(94, 0, 240, 0.15)',
      endColor: 'rgba(0, 96, 250, 0.55)',
      scale: [1, 1],
    },
    stroke: {
      startColor: 'rgba(53, 196, 255, 1)',
      endColor: 'rgba(0, 96, 250, 1)',
    },
  },
  gradient4: {
    fill: {
      startColor: 'rgba(227, 96, 36, 0.15)',
      endColor: 'rgba(218, 54, 46, 0.55)',
      scale: [1, 1.7045],
    },
    stroke: {
      startColor: 'rgba(218, 54, 46, 1)',
      endColor: 'rgba(242, 149, 56, 1)',
    },
  },
  gradient5: {
    fill: {
      startColor: 'rgba(253, 196, 13, 0.15)',
      endColor: 'rgba(247, 142, 30, 0.55)',
      scale: [1, 1],
    },
    stroke: {
      startColor: 'rgba(253, 112, 13, 1)',
      endColor: 'rgba(246, 199, 19, 1)',
    },
  },
};

export default gradients;
